import open from '../../../../../assets/Buzon/CorreoAbierto.svg';
import closed from '../../../../../assets/Buzon/CorreoCerrado.svg';

import './PreView.css'

const PreView = (props) => {


    return(
        <div className='messege-preview' onClick={() => {props.setSelectedType({type:1, messege:props.messege}); props.messege.is_read = true}}>
            <img className='messege-preview-state-icon' src={props.messege.is_read ? open : closed} />
            <div className='messege-preview-content'>
                <h2 className='messege-preview-title'>{props.messege.subject}</h2>
                <h5 className='messege-prebiew-from'>De: {props.messege.name}</h5>
            </div>
        </div>
    )

}

export default PreView;